import "./static/utf8-php/ueditor.config.js";
import "./static/utf8-php/ueditor.all.min.js";
import App from './App';
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router';
import routes from './routes';
import cookie from 'vue-cookie';
import { post, get, patch, put } from './common/http';
import global_ from './common/Global';

import Calendar from 'vue-mobile-calendar';//移动端时间插件
import VueClipboard from 'vue-clipboard2';

import './assets/common/public.css'

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$Global = global_;


Vue.prototype.$cookies = cookie; 
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(Calendar);
Vue.use(VueClipboard);
const router = new VueRouter({
  	mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
if(to.path == '/') {
    next({ path: '/Login'});
}else {
    next();
}
});

new Vue({
  router,
  data: function(){
      return {
        CommTable: '',
      }
  },
  render: h => h(App)
}).$mount('#app');
